export default "__VITE_ASSET__CfumxZrA__"